import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import * as FileSaver from "file-saver";
import { JniToastrService } from "../../../../core/services/jni-toastr.service";
import { ProgramListDto } from "../../../../core/models/program/programListDto";
import { LoaderService } from "../../../../core/services/loader.service";
import { ProgramsService } from "../../../../core/services/programs.service";
import { TableFilterEvent, TableModule } from "primeng/table";
import { ModalStackerComponent } from "../../../../shared/components/modal-stacker/modal-stacker.component";
import { ProgramSummaryComponent } from "../program-summary/program-summary.component";
import { CommonModule } from "@angular/common";
import { SpinnerComponent } from "../../../../shared/components/spinner/spinner.component";
import { RadioButtonModule } from "primeng/radiobutton";
import { ButtonModule } from "primeng/button";
import { CardModule } from "primeng/card";
import { InputTextModule } from "primeng/inputtext";

@UntilDestroy()
@Component({
  selector: "jni-programs-listing",
  templateUrl: "./programs-listing.component.html",
  styleUrls: ["./programs-listing.component.scss"],
  imports: [
    TableModule,
    ModalStackerComponent,
    ProgramSummaryComponent,
    CommonModule,
    SpinnerComponent,
    ButtonModule,
    CardModule,
    InputTextModule,
    RadioButtonModule,
  ],
})
export class ProgramsListingComponent implements OnInit {
  programListing: ProgramListDto[] = [];
  filteredProgramListing: ProgramListDto[] = [];
  selectedProgramListing: ProgramListDto[] = [];
  listAfterGridFilter: ProgramListDto[] = [];
  showSmallLoader = false;
  showClientData = false;
  programId = 0;
  programDisplayModel = false;

  constructor(
    private _router: Router,
    private _loaderService: LoaderService,
    private _progarmService: ProgramsService,
    private _toastr: JniToastrService
  ) {}

  ngOnInit() {
    this.getProgramList();
  }

  onAddProgramRedirection() {
    this._router.navigate(["programs/program-header"]);
  }

  onFilter(event: TableFilterEvent) {
    if (event?.filters && event?.filteredValue?.length !== 0) {
      this.listAfterGridFilter = event.filteredValue;
    } else {
      this.listAfterGridFilter = [];
    }
  }

  redirectToSummary(programId: number) {
    if (programId) {
      this.programId = programId;
      this.programDisplayModel = true;
    }
  }

  closeModalForProgram() {
    this.programDisplayModel = false;
    this.getProgramList();
  }

  showOrHideClientColumn(check: boolean) {
    this.showClientData = check;
    this.getProgramList();
  }

  getProgramList() {
    this._loaderService.setLoaderState(true);
    this._progarmService
      .getAllProgramList(this.showClientData)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this._loaderService.setLoaderState(false);
          this.programListing = res.data;
          if (this.programListing?.length > 0) {
            this.filteredProgramListing = this.programListing;
          }
        },
        error: res => {
          this._loaderService.setLoaderState(false);
          this._toastr.error("Error", res.message ?? "Data not found");
        },
      });
  }

  exportExcel() {
    this.showSmallLoader = true;

    if (this.listAfterGridFilter?.length > 0) {
      this.exportExcelForFilterData(this.listAfterGridFilter);
    } else {
      this.exportExcelForFilterData(this.filteredProgramListing);
    }
    this.showSmallLoader = false;
  }

  exportExcelForFilterData(filterclientlist: ProgramListDto[]) {
    const object = filterclientlist.map(datum => {
      return {
        ["Program"]: datum.name,
        ["BC"]: datum.brandingConsultantNameD365
          ? datum.brandingConsultantD365 +
            ":" +
            datum.brandingConsultantNameD365
          : "",
        ...(this.showClientData === true && {
          ["Client Name"]: datum.clientName,
        }),
        ...(this.showClientData === true && {
          ["Client#"]: datum.clientId,
        }),

        ...(this.showClientData === true && {
          ["Client Added"]: datum.clientAdded,
        }),

        ["Status"]: datum.programStatus,
        ["D365-DIM"]: datum.dimensionD365,

        ...(this.showClientData === true && {
          ["DFLT-DIm"]: datum.defaultClient === true ? "Yes" : "No",
        }),

        ...(this.showClientData === true && {
          ["Date Added"]: datum.dateAdded,
        }),

        ["Nadel Inv"]: datum.nadelOwnInv ? "Yes" : "No",
        ["Website"]: datum.usesWebsite ? "Yes" : "No",
        ["Warehouse"]: datum.uses3PL ? "Yes" : "No",
        ["Microsite"]: datum.micro ? "Yes" : "No",
        ["Client Inv"]: datum.clientOwnInv ? "Yes" : "No",
        ["Intl"]: datum.intl ? "Yes" : "No",
        ["CC"]: datum.inStoreCC ? "Yes" : "No",
      };
    });

    import("xlsx").then(xlsx => {
      const worksheet = xlsx.utils.json_to_sheet(object);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
      const excelBuffer: ArrayBuffer = xlsx.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });
      this.saveAsExcelFile(excelBuffer, "ProgramList");
    });
  }

  saveAsExcelFile(buffer: ArrayBuffer, fileName: string): void {
    const EXCEL_TYPE =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    const EXCEL_EXTENSION = ".xlsx";
    const data: Blob = new Blob([buffer], {
      type: EXCEL_TYPE,
    });
    FileSaver.saveAs(
      data,
      fileName + "_export_" + new Date().getTime() + EXCEL_EXTENSION
    );
  }
}
